export class ReplicatedAction {
    constructor(className, validator, effect) {
        this.__data = null;
        this.validator = validator;
        this.effect = effect;
        this.className = className;
    }
}
//# sourceMappingURL=ReplicatedAction.js.map